import { MemberStatus } from '../project-members.enum'
import { mergeProjectMembersList } from '../project-members.utils'

import type { ProjectsStore } from './projects.type'

export const selectProjectMembersServer = (state: ProjectsStore) => state.projectMembersServer

export const selectActiveProjectMembersServerCount = (state: ProjectsStore) =>
  state.projectMembersServer.filter((member) => member.status === MemberStatus.ACTIVE).length

export const selectProjectMembersPending = (state: ProjectsStore) => state.projectMembersPending

export const selectProjectMembersError = (state: ProjectsStore) => state.projectMembersError

export const selectProjectMembersReadyProjectId = (state: ProjectsStore) => state.projectMembersReadyProjectId

export const selectProjectMembersList = (state: ProjectsStore) =>
  mergeProjectMembersList(state.projectMembersServer, state.projectMembersPending)

export const selectProjectMembersListReady = (projectId: string | undefined) => (state: ProjectsStore) =>
  Boolean(projectId && state.projectMembersReadyProjectId === projectId)

export const selectCurrentProject = (state: ProjectsStore) => state.currentProject

export const selectCurrentProjectId = (state: ProjectsStore) => state.currentProject?.projectId ?? null

export const selectCurrentProjectName = (state: ProjectsStore) => state.currentProject?.name ?? ''

export const selectProjects = (state: ProjectsStore) => state.projects

export const selectAllProjects = (state: ProjectsStore) => state.allProjects

export const selectProjectsLoading = (state: ProjectsStore) => state.loading

export const selectProjectsFetchState = (state: ProjectsStore) => ({
  loading: state.loading,
  error: state.error,
})

export const selectHasNoProjects = (state: ProjectsStore) => state.projects.length === 0

export const selectIsResolvingWorkspaceProject = (state: ProjectsStore) => state.isResolvingWorkspaceProject

export const selectUserProjectsFetched = (state: ProjectsStore) => state.userProjectsFetched

export const selectProjectsContextLoading = (state: ProjectsStore) => state.loading || state.isResolvingWorkspaceProject

export const selectProjectsShellState = (state: ProjectsStore) => ({
  projects: state.projects,
  currentProject: state.currentProject,
  loading: state.loading,
})

export const selectProjectsDashboardState = (state: ProjectsStore) => ({
  projects: state.projects,
  currentProject: state.currentProject,
  loading: state.loading,
  contextLoading: state.loading || state.isResolvingWorkspaceProject,
  hasNoProjects: state.projects.length === 0,
  isResolvingWorkspaceProject: state.isResolvingWorkspaceProject,
  userProjectsFetched: state.userProjectsFetched,
})

export const selectProjectMembersContextState = (state: ProjectsStore) => ({
  currentProject: state.currentProject,
  loading: state.loading,
  error: state.error,
})

export const selectProjectsConferenceSelectState = (state: ProjectsStore) => ({
  projects: state.projects,
  currentProject: state.currentProject,
  isResolvingWorkspaceProject: state.isResolvingWorkspaceProject,
})

export const selectProjectsListFetchState = (state: ProjectsStore) => ({
  projects: state.projects,
  loading: state.loading,
  userProjectsFetched: state.userProjectsFetched,
})

export const selectProjectMembersRawState = (state: ProjectsStore) => ({
  membersError: state.projectMembersError,
  serverMembers: state.projectMembersServer,
  pendingInvites: state.projectMembersPending,
})

export const selectProjectMembersMutations = (state: ProjectsStore) => ({
  loadProjectMembers: state.loadProjectMembers,
  resetProjectMembers: state.resetProjectMembers,
  setPendingInvites: state.setProjectMembersPending,
  setServerMembers: state.setProjectMembersServer,
})
